export const colors = ['white', 'black'];
export const files = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
export const ranks = ['1', '2', '3', '4', '5', '6', '7', '8'];
//# sourceMappingURL=types.js.map